/** Pixel edits saved by the browser-based tileset designer. */
export const TILE_OVERRIDES = {};
